import React from 'react';
import { stats } from '../data/content';
import { Reveal } from './ui/Reveal';
export function StatsBar() {
  return <section className="bg-white px-4 py-10 sm:px-5 sm:py-12" data-id="element-245" data-mp="1tbjift0ew4fe">
      <Reveal data-id="element-246" data-mp="1obf160roj5o4">
        <div className="mx-auto grid max-w-6xl grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-4" data-id="element-247" data-mp="1oavph1smhdij">
          {stats.map(stat => <div key={stat.label} className="rounded-[1.25rem] bg-cream px-4 py-7 text-center sm:rounded-[1.5rem] sm:px-5 sm:py-9" data-id="element-248" data-mp="1jd3rpr5aqx6f">
              <p className="display text-[2rem] text-orange sm:text-5xl" data-id="element-249" data-mp="1eeimfdb6tnb4">
                {stat.value}
              </p>
              <p className="mx-auto mt-2.5 max-w-[16ch] text-[10px] font-black uppercase leading-snug tracking-[0.08em] text-ink/60 sm:mt-3 sm:text-xs sm:tracking-[0.1em]" data-id="element-250" data-mp="19ko52gj21kf7">
                {stat.label}
              </p>
            </div>)}
        </div>
      </Reveal>
    </section>;
}